module.exports = __webpack_public_path__ + "img/26.e038e0f5.png";